<template>
  <app-select-box
    :label-text="layout.levelLabel"
    :options="levelsList"
    :selected="activeLevel.id"
    :on-change-cb="handleLevelChange"
    :has-default-option-null="true"
  />
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "LevelsSelector",
  computed: {
    ...mapGetters({
      levelsList: "level/getLevelsList",
      activeLevel: "delivery/getSelectedLevel",
      activeVenueId: "venue/getActiveVenue",
      layout: "venueSettings/getLayout"
    })
  },
  methods: {
    ...mapActions({
      fetchLevelSeats: "level/fetchLevelSeats"
    }),
    ...mapMutations({
      setSelectedLevel: "delivery/setSelectedLevel"
    }),
    fetchVenueLevelSeats(selected) {
      return this.fetchLevelSeats({
        venueId: this.activeVenueId,
        levelId: selected
      });
    },
    handleLevelChange(event) {
      const selectedLevel = event.target.value;
      this.fetchVenueLevelSeats(selectedLevel);
      this.setSelectedLevel({ levelId: selectedLevel });
    }
  },
  mounted() {
    this.fetchVenueLevelSeats(this.activeLevel.id || this.levelsList[0].id);
  }
};
</script>
